<template>
  <router-link to='/dashboard'>
    <img src="/static/newlogo.png" alt="logo"/>
  </router-link>
</template>

<script>
  export default { name: 'logotype' }
</script>

<style scoped lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';
  a {
    &:hover {
      text-decoration: none;
    }
  }

  .logo__img {
    img {
      width: 188px;
      height: 60px;
    }
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: $default-light-white;
    font-size: 32px; /* adjust until it fits well */
    line-height: 60px;


    @include respond-to(small) {
      width: 120px;
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/common/Logotype.vue